import { render } from "./AddFieldButton.vue?vue&type=template&id=b869270c"
import script from "./AddFieldButton.vue?vue&type=script&lang=js"
export * from "./AddFieldButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__